import React from 'react';
import zola from '../../public/static/zola.png';
import cratebarrel from '../../public/static/cratebarrel.png';
import macys from '../../public/static/macys.png';
import bridePic from '../../public/static/bridePic.png';
import groomPic from '../../public/static/groomPic.png';

const config = {
  site: {
    backgroundColor: '#f8f8f8',
    navColor: '#D95E39',
    textColor: '#001f3f',
    title: 'Lauren and Dylan Wedding Site',
    description: 'Lauren Birnbaum and Dylan Sather wedding website',
    keywords: 'Lauren Birnbaum, Dylan Sather, wedding',
  },
  img: {
    bridePic,
    groomPic,
  },
  wedding: {
    date: '9/15/2018',
    location: 'Sebastopol, CA',
    startTime: '4:00',
    endTime: '10:00pm',
    arrivalTime: '3:45pm',
  },
  welcomeParty: {
    date: '9/14/2018',
    startTime: '8:00',
    endTime: '11:00pm',
    location: (
      <p>
        <a href="http://woodfourbrewing.com/">Woodfour Brewing Company</a>
        <br />
        <a href="https://www.google.com/maps/place/Woodfour+Brewing+Company/@38.4036314,-122.8212714,15z/data=!4m2!3m1!1s0x0:0x74a3f59b72910059?sa=X&ved=2ahUKEwj8nve5lbndAhVFlVQKHZfqDo0Q_BIwCnoECAoQCw">
          Directions
        </a>
        <br />
        <br />
        <span
          style={{
            fontStyle: 'italic',
          }}>
          Parking is available across the street in the Barlow. Lyft/Uber also
          available.
        </span>
      </p>
    ),
  },
  afterParty: {
    startTime: '10:00pm',
    endTime: 'Midnight',
    location: (
      <p>
        Sky Bar @<a href="https://www.gratonresortcasino.com/">Graton Casino</a>
        <br />
        <a href="https://www.google.com/maps/place/Graton+Resort+%26+Casino/@38.3607577,-122.722795,15z/data=!4m2!3m1!1s0x0:0x81db74f6d3a83de0?sa=X&ved=2ahUKEwjH24zomrndAhWpjlQKHeAYAwcQ_BIwDXoECAgQCw">
          Directions
        </a>
      </p>
    ),
    directions: (
      <span
        style={{
          fontStyle: 'italic',
        }}>
        Shuttle will be provided to Casino @10pm. If you wish to go back to
        Oxford Suites, there will also be a return shuttle @9:45pm, 10pm &amp;
        10:15pm
      </span>
    ),
  },
  brunch: {
    date: '9/16/2018',
    startTime: '10:00am',
    endTime: 'Noon',
    location: (
      <p>
        Redwood #2 Room @
        <a href="https://www.oxfordsuitessonoma.com/">
          Oxford Suites Sonoma County - Rohnert Park
        </a>
        <br />
        <a href="https://www.google.com/maps/place/Oxford+Suites+Sonoma+County+-+Rohnert+Park/@38.3635348,-122.716971,15z/data=!4m2!3m1!1s0x0:0xc16838edd4db6185?sa=X&ved=2ahUKEwiDjoTWmrndAhWCiVQKHb58CbIQ_BIwCnoECAoQCw">
          Directions
        </a>
      </p>
    ),
  },
  personalInfo: {
    bride: 'Lauren',
    groom: 'Dylan',
  },
  travel: {
    airports: [
      {
        name: 'Oakland',
        code: 'OAK',
        distance: '1 hour, 30 min',
      },
      {
        name: 'San Francisco',
        code: 'SFO',
        distance: '1 hour, 30 min',
      },
      {
        name: 'San Jose',
        code: 'SJC',
        distance: '2 hours',
      },
      {
        name: 'Sacramento',
        code: 'SMF',
        distance: '2 hours',
      },
    ],
  },
  navBarLinks: [
    {
      link: '/about',
      title: 'ABOUT US',
    },
    {
      link: '/schedule',
      title: 'SCHEDULE',
    },
    {
      link: '/travelaccommodations',
      title: 'TRAVEL & ACCOMMODATIONS',
    },
    {
      link: '/thingstosee',
      title: 'THINGS TO SEE',
    },
    {
      link: '/venue',
      title: 'VENUE',
    },
    {
      link: '/registry',
      title: 'REGISTRY',
    },
    {
      link: '/rsvp',
      title: 'RSVP',
    },
  ],
  venue: {
    title: 'Sova Gardens',
    physicalAddr: '5186 Gravenstein Hwy S, Sebastopol, CA 95472',
    webAddr: 'http://www.sovagardens.com/',
    googleMapsLink:
      'https://www.google.com/maps/place/Sova+Gardens/@38.3485222,-122.7628139,15z/data=!4m5!3m4!1s0x0:0x8aa28037fc75039b!8m2!3d38.3485222!4d-122.7628139',
    drivingNotes:
      'Shuttle will be provided from Oxford Suites Hotel @3:15pm and 3:30pm. There is a parking lot on site and you are able to leave your car there overnight, until Noon Sunday. Lyft/Uber also available.',
  },
  hotel: {
    title: 'Oxford Suites',
    blockDescription: (
      <p>
        We have a block of rooms at the{' '}
        <a href="https://www.oxfordsuitessonoma.com/">
          Oxford Suites (Sonoma County)
        </a>{' '}
        <strong>available to book until August 1, 2018</strong>. Reservations
        can be made by calling the hotel directly at 707-584-0333 and mentioning
        the Birnbaum Sather Wedding to get the discounted rate. A two night stay
        minimum is required to book.
      </p>
    ),
    listOfHotelsInArea: [
      {
        title: 'Sebastopol Inn',
        link: 'http://www.sebastopolinn.com/',
      },
      {
        title: 'Hampton Inn & Suites Rohnert Park - Sonoma County',
        link:
          'http://hamptoninn3.hilton.com/en/hotels/california/hampton-inn-and-suites-rohnert-park-sonoma-county-STSRPHX/index.html',
      },
      {
        title: 'DoubleTree by Hilton Hotel Sonoma Wine Country',
        link:
          'http://doubletree3.hilton.com/en/hotels/california/doubletree-by-hilton-hotel-sonoma-wine-country-RLSC-DT/index.html',
      },
      {
        title: 'Fairfield Inn & Suites Santa Rosa Sebastopol',
        link: 'http://www.winecountryhi.com/#gref',
      },
      {
        title: 'Graton Resort and Casino',
        link: 'https://www.gratonresortcasino.com/',
      },
    ],
  },
  surroundingArea: {
    name: 'Sonoma',
    airbnbLink: 'https://www.airbnb.com/s/santa-rosa--ca/all',
    introText: (
      <div>
        <p>
          Sonoma is a destination on its own and we hope you get a couple of
          days before or after the wedding to explore. There’s something for
          everyone here: great wineries, cheese, food, beaches, redwood forests,
          and more. September is one of the best months to visit the Bay Area.
        </p>
        <p>Here are a few of our favorite, more unique spots:</p>
      </div>
    ),
    thingsToSee: [
      {
        text: (
          <span>
            <a
              href="https://hogislandoysters.com/locations/marshall"
              target="_blank">
              Hog Island Oysters
            </a>{' '}
            (Tomales Bay)
          </span>
        ),
      },
      {
        text: (
          <span>
            <a
              href="https://www.cowgirlcreamery.com/pt-reyes-shop-creamery"
              target="_blank">
              Cowgirl Creamery
            </a>{' '}
            (Point Reyes Station)
          </span>
        ),
      },
      {
        text: (
          <span>
            <a href="http://www.barndiva.com/" target="_blank">
              Barn Diva
            </a>{' '}
            (Healdsburg)
          </span>
        ),
      },
      {
        text: <span>Stinson Beach</span>,
      },
      {
        text: (
          <span>
            Downtown Sebastopol, near the wedding venue, has great food, ice
            cream, and shopping
          </span>
        ),
      },
      {
        text: (
          <span>
            <a
              href="https://www.tripadvisor.com/Attractions-g33107-Activities-c36-t132-Sonoma_Sonoma_County_California.html"
              target="_blank">
              Top Wineries in the area
            </a>
          </span>
        ),
      },
      {
        text: (
          <span>
            <a href="https://lagunitas.com/taproom/petaluma" target="_blank">
              Lagunitas Taproom
            </a>{' '}
            (Petaluma)
          </span>
        ),
      },
      {
        text: (
          <span>
            <a href="https://bearrepublic.com/" target="_blank">
              Bear Republic Brewery
            </a>{' '}
            (Rohnert Park)
          </span>
        ),
      },
      {
        text: (
          <span>
            <a href="https://www.gratonresortcasino.com/" target="_blank">
              Graton Casino
            </a>{' '}
            (we’ll be heading here after the wedding, too!)
          </span>
        ),
      },
      {
        text: (
          <span>
            <a href="https://www.nps.gov/muwo/index.htm" target="_blank">
              Muir Woods
            </a>,{' '}
            <a
              href="https://www.google.com/maps/place/Mt+Tamalpais/@37.9235421,-122.6139801,14z/data=!3m1!4b1!4m5!3m4!1s0x808591171b36502f:0x64161469a5add222!8m2!3d37.9235439!4d-122.5964705"
              target="_blank">
              Mt. Tam
            </a>{' '}
            for the more adventurous hikers
          </span>
        ),
      },
      {
        text: (
          <span>
            Sausalito &amp; Tiburon (two small bayside towns just north of San
            Francisco)
          </span>
        ),
      },
    ],
  },
  registries: [
    {
      name: 'zola',
      link: 'https://www.zola.com/registry/laurenanddyl',
      img: zola,
    },
  ],
  rsvp: {
    formHTML: (
      <iframe
        src="https://docs.google.com/forms/d/e/1FAIpQLSfJG6_RQxUkjtiUAk01ogRJDIfgr00QcmurTgw-29hzZt2_eQ/viewform?embedded=true"
        width="750"
        height="500"
        frameBorder="0"
        marginHeight="0"
        marginWidth="0">
        Loading...
      </iframe>
    ),
  },
};

export default config;



// WEBPACK FOOTER //
// ./src/utils/config.js